module.exports = __webpack_public_path__ + "img/5.2d5b1715.png";